import { render, staticRenderFns } from "./AddInquiry.vue?vue&type=template&id=049745ae&scoped=true&"
import script from "./AddInquiry.vue?vue&type=script&lang=js&"
export * from "./AddInquiry.vue?vue&type=script&lang=js&"
import style0 from "./AddInquiry.vue?vue&type=style&index=0&id=049745ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049745ae",
  null
  
)

export default component.exports